import { Voucher } from '@oresundsbron/api';
import { Box } from '@oresundsbron/bridge-ui';

import { AquireModal } from '../AquireModal';

export const RedeemButton = ({
  voucher,
  title,
}: {
  voucher: Voucher;
  title: string;
}) => (
  <Box className="mt-3 flex justify-center">
    <AquireModal voucher={voucher} title={title} />
  </Box>
);
